import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Box, Button, FormControl, FormLabel, Input, Stack, Text, useToast,
} from '@chakra-ui/react';

import { useAuth } from '../contexts/AuthContext';

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { updatePassword } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast({
        title: "Error",
        description: "Passwords do not match",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);

    try {
      await updatePassword(password);
      toast({
        title: "Success",
        description: "Your password has been updated",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/login");
    } catch (error) {
      toast({
        title: "Error",
        description:
          error instanceof Error ? error.message : "Failed to update password",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" py={12} px={{ base: 4, sm: 6, lg: 8 }}>
      <Box maxW="md" mx="auto">
        <Stack spacing={8}>
          <Stack spacing={6}>
            <Stack spacing={3} textAlign="center">
              <Text fontSize="3xl" fontWeight="bold">
                Set new password
              </Text>
              <Text color="gray.600">Please enter your new password below</Text>
            </Stack>
          </Stack>

          <Box
            py={8}
            px={4}
            shadow="base"
            rounded="lg"
            bg="white"
            _dark={{ bg: "gray.700" }}
          >
            <form onSubmit={handleSubmit}>
              <Stack spacing={6}>
                <FormControl id="password">
                  <FormLabel>New Password</FormLabel>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </FormControl>

                <FormControl id="confirmPassword">
                  <FormLabel>Confirm New Password</FormLabel>
                  <Input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </FormControl>

                <Button
                  type="submit"
                  colorScheme="blue"
                  size="lg"
                  fontSize="md"
                  isLoading={isLoading}
                >
                  Update Password
                </Button>
              </Stack>
            </form>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
